(function () {
  function syncSection(section) {
    if (!section) return;
    var button = section.querySelector('[data-mbb-subtheme-toggle]');
    if (!button) return;

    var hiddenCards = section.querySelectorAll('[data-mbb-hidden-card]');
    if (!hiddenCards.length) {
      button.hidden = true;
      return;
    }

    var expanded = button.getAttribute('aria-expanded') === 'true';
    hiddenCards.forEach(function (card) {
      card.hidden = !expanded;
      card.classList.toggle('is-hidden', !expanded);
    });

    var showLabel = button.getAttribute('data-show-label') || 'Preview more sub-themes';
    var hideLabel = button.getAttribute('data-hide-label') || 'Hide extra sub-themes';
    button.textContent = expanded ? hideLabel : showLabel;
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-mbb-subtheme-section]');
    sections.forEach(syncSection);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mbb-subtheme-toggle]');
    if (!button) return;

    var section = button.closest('[data-mbb-subtheme-section]');
    if (!section) return;

    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    syncSection(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll(document);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[data-mbb-subtheme-section]') : null;
    if (section) initAll(section);
  });
})();
